module.exports = __webpack_public_path__ + "img/Asset.c99635ff.svg";